import axios from "./interceptor";

export const loginApi = async userData => {
    try {
        const response = await axios.post("/auth/adminLogin", userData);
        return response.data.data.token;
    } catch (e) {
        throw e.response.data;
    }
};

export const sendOtp = async data => {
    try {
        const response = await axios.post("/auth/sendOtp", data);
        return response.data.message;
    } catch (e) {
        throw e.response.data;
    }
};

export const login = async data => {
    try {
        const response = await axios.post("/auth/verifyOtp", data);
        return response.data;
    } catch (error) {
        console.log(error);
        if (error.response) {
            return Promise.reject(error.response.data);
        } else if (error.request) {
            return Promise.reject({ message: "Network Error" });
        } else {
            return Promise.reject({ message: error.message });
        }
    }
};
